import { Box, ColorOptions, Icon, ModalDialogNew, ModBox, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useState } from 'react'
import { Routes } from '../../nav/routes'
import { Colors } from '../../util/util'
import { FiltersView } from './FiltersView'

export const SearchBarWithFilters = ({ onApply, showSearch = true }: any) => {
  const navigation = useNavigation()
  const [filtersVisible, setFiltersVisible] = useState(false)

  const handleAppy = () => {
    setFiltersVisible(false)
    onApply()
  }

  const handleClearAll = () => {
    setFiltersVisible(false)
    onApply()
  }

  return (
    <>
      <Box
        ph={24}
        justify={showSearch ? 'space-between' : 'flex-end'}
        bg="TRANSPARENT"
        align={'center'}
        flexDirection={'row'}
        pv={10}
        pt={20}>
        <ModBox
          show={showSearch}
          borderColor={Colors.GREY_BG as ColorOptions}
          borderWidth={1}
          borderRadius={8}
          flexDirection={'row'}
          align={'center'}
          gap={8}
          pl={16}
          h={40}
          f={1}
          underlayColor={'TRANSPARENT'}
          testID="search"
          onPress={() => navigation?.navigate(Routes.BILLPAY_SEARCH as never)}>
          <Icon id={'SEARCH'} color={Colors.GREY_BG as ColorOptions} size={16} />
          <Text
            fontFamily="JioType-Medium"
            fontSize={14}
            title="Search Transactions"
            color={Colors.PRIMARY_GREY as ColorOptions}
          />
        </ModBox>
        <Box
          flexDirection={'row'}
          align={'center'}
          pl={10}
          underlayColor={'TRANSPARENT'}
          testID="show-filter"
          onPress={() => setFiltersVisible(true)}>
          <Box pr={5}>
            <Icon id={'FILTER2'} color={Colors.BLACK_14 as ColorOptions} size={16} />
          </Box>
          <Text
            fontFamily="JioType-Medium"
            fontSize={14}
            title="Filters"
            lineHeight={16}
            letterSpacing={-0.06}
            color={Colors.BLACK_14 as ColorOptions}
          />
        </Box>

        <ModalDialogNew show={filtersVisible} animate={true} type="bottom" backgroundColor="TRANSPARENT">
          <Box bg={'WHITE'} borderTopLeftRadius={24} borderTopRightRadius={24}>
            <FiltersView
              applyFilters={handleAppy}
              clearFilters={handleClearAll}
              cancel={() => setFiltersVisible(false)}
            />
          </Box>
        </ModalDialogNew>
      </Box>
    </>
  )
}
